import { render, staticRenderFns } from "./OrderTableView.vue?vue&type=template&id=4cf939da&"
import script from "./OrderTableView.vue?vue&type=script&lang=js&"
export * from "./OrderTableView.vue?vue&type=script&lang=js&"
import style0 from "./OrderTableView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports